import React from 'react';
import { mergeStyles } from 'src/_shared/utils/mergeStyles';
import { ButtonProps, ButtonPersonalizedStyles } from './Button.types';

export function withPersonalizedButtonStyle<T extends ButtonProps>(
  Component: React.ComponentType<T & ButtonPersonalizedStyles>,
  styles: ButtonPersonalizedStyles,
) {
  return ({
    style,
    innerStyle,
    textStyle,
    textDisabledStyle,
    textHoverStyle,
    textPressedStyle,
    textFocusStyle,
    iconStyle,
    iconHoverStyle,
    iconDisabledStyle,
    iconPressedStyle,
    disabledStyle,
    focusStyle,
    hoverStyle,
    pressedStyle,
    ...props
  }: T) => {
    return (
      <Component
        style={mergeStyles(styles.button, style)}
        innerStyle={mergeStyles(styles.buttonInner, innerStyle)}
        disabledStyle={mergeStyles([styles.buttonDisabled, disabledStyle])}
        focusStyle={mergeStyles([styles.buttonFocus, focusStyle])}
        hoverStyle={mergeStyles([styles.buttonHover, hoverStyle])}
        pressedStyle={mergeStyles([styles.buttonPressed, pressedStyle])}
        textStyle={mergeStyles(styles.text, textStyle)}
        textDisabledStyle={mergeStyles([styles.textDisabled, textDisabledStyle])}
        textFocusStyle={mergeStyles([styles.textFocus, textFocusStyle])}
        textHoverStyle={mergeStyles([styles.textHover, textHoverStyle])}
        textPressedStyle={mergeStyles([styles.textPressed, textPressedStyle])}
        iconStyle={mergeStyles(styles.icon, iconStyle)}
        iconHoverStyle={mergeStyles(styles.iconHover, iconHoverStyle)}
        iconDisabledStyle={mergeStyles(styles.iconDisabled, iconDisabledStyle)}
        iconPressedStyle={mergeStyles(styles.iconPressed, iconPressedStyle)}
        {...props}
      />
    );
  };
}
